export const designTokens = {
  typography: {
    family: {
      sans: '"Manrope", Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      serif: '"Newsreader", Georgia, "Times New Roman", serif',
      mono: '"SFMono-Regular", Consolas, "Liberation Mono", monospace'
    },
    size: {
      11: "0.6875rem",
      12: "0.75rem",
      13: "0.8125rem",
      14: "0.875rem",
      16: "1rem",
      18: "1.125rem",
      20: "1.25rem",
      24: "1.5rem",
      30: "1.875rem",
      36: "2.25rem"
    },
    weight: { regular: 400, medium: 500, semibold: 600, bold: 700 },
    lineHeight: {
      16: "1rem",
      18: "1.125rem",
      20: "1.25rem",
      24: "1.5rem",
      26: "1.625rem",
      28: "1.75rem",
      32: "2rem",
      38: "2.375rem",
      44: "2.75rem"
    },
    letterSpacing: { tight: "-0.01em", normal: "0", wide: "0.08em" }
  },
  space: {
    0: "0",
    1: "0.25rem",
    2: "0.5rem",
    3: "0.75rem",
    4: "1rem",
    5: "1.5rem",
    6: "2rem",
    7: "2.5rem",
    8: "3rem",
    9: "4rem"
  },
  size: {
    0: "0",
    1: "0.125rem",
    2: "0.25rem",
    3: "0.5rem",
    4: "0.75rem",
    5: "1rem",
    6: "1.25rem",
    7: "1.5rem",
    8: "2rem",
    9: "2.5rem",
    10: "3rem",
    11: "4rem"
  },
  width: {
    sidebarExpanded: "14.5rem",
    sidebarCollapsed: "4.5rem",
    drawerNarrow: "25rem",
    drawerStandard: "32.5rem",
    drawerWide: "42.5rem",
    contextRail: "20rem",
    reading: "45rem",
    consequential: "60rem",
    workspaceMax: "90rem"
  },
  radius: {
    0: "0",
    1: "0.25rem",
    2: "0.375rem",
    3: "0.5rem",
    4: "0.75rem",
    pill: "999px"
  },
  color: {
    white: "#ffffff",
    black: "#000000",
    surfaceCanvas: "#f9f8f6",
    surface: "#ffffff",
    surfaceSubtle: "#f1efea",
    surfaceHover: "#eceae4",
    surfaceSelected: "#e8eef6",
    surfaceDisabled: "#f1efea",
    textStrong: "#1c1b19",
    textDefault: "#3a3834",
    textMuted: "#6e6a63",
    textSubtle: "#8a8580",
    textDisabled: "#6e6a63",
    textOnAccent: "#fdf9f4",
    textOnDark: "#f2efe9",
    border: "#e8e4dc",
    borderStrong: "#d4cfc4",
    accent: "#6b2435",
    accentHover: "#5a1e2c",
    accentPressed: "#4a1824",
    accentSubtle: "#f4e6e9",
    accentText: "#6b2435",
    secondary: "#7f9fbf",
    secondaryHover: "#6a8aad",
    secondarySubtle: "#e8eef6",
    secondaryText: "#3d5a78",
    success: "#5a6b45",
    successBackground: "#e8eee0",
    warning: "#8a4a3a",
    warningBackground: "#f6e2dc",
    danger: "#a83c3c",
    dangerBackground: "#fbeaea",
    info: "#3d5a78",
    infoBackground: "#e8eef6",
    neutralState: "#5c5c3d",
    neutralStateBackground: "#eae8d9",
    ai: "#53618b",
    aiBackground: "#e8ecf5",
    chartSlate: "#8a8580",
    chartBlue: "#7f9fbf",
    chartBlueSoft: "#b7c9dc",
    chartPink: "#c4a8ad",
    chartAmber: "#7f9fbf",
    chartPlum: "#6b2435",
    chartOlive: "#7a8a68",
    chartTaupe: "#9a8b7c",
    focus: "#8a2d44",
    shellBg: "#141416",
    shellBgHover: "#1e1e21",
    shellBgActive: "#26262b",
    shellBorder: "#2a2a2e",
    shellText: "#f2efe9",
    shellTextMuted: "#b4afa6",
    shellTextFaint: "#7e7b75"
  },
  border: { width0: "0", width1: "1px", width2: "2px" },
  elevation: {
    0: "none",
    1: "0 1px 2px rgb(28 24 20 / 4%), 0 8px 24px -16px rgb(28 24 20 / 8%)",
    menu: "0 10px 28px rgb(28 24 20 / 14%)",
    dialog: "0 20px 56px rgb(28 24 20 / 20%)"
  },
  icon: { small: "0.875rem", default: "1.125rem", large: "1.25rem", strokeWidth: 1.75 },
  control: {
    compact: "2rem",
    default: "2.5rem",
    touch: "2.75rem",
    tableHeader: "2.5rem",
    tableRowCompact: "2.5rem",
    tableRowDefault: "3rem"
  },
  motion: {
    instant: "1ms",
    fast: "120ms",
    standard: "180ms",
    slow: "240ms",
    easingStandard: "cubic-bezier(0.2, 0, 0, 1)",
    easingExit: "cubic-bezier(0.4, 0, 1, 1)"
  },
  focusRing: "0 0 0 2px #ffffff, 0 0 0 4px #8a2d44",
  zIndex: {
    base: 0,
    sticky: 100,
    dropdown: 300,
    overlay: 400,
    drawer: 500,
    modal: 600,
    toast: 700,
    tooltip: 800,
    skipLink: 900
  },
  breakpoint: { mobile: 768, desktop: 1024, wide: 1440 }
} as const;

export type DesignTokens = typeof designTokens;
export type Breakpoint = keyof DesignTokens["breakpoint"];
